angular.module('eStories.promoEligibility', [
    'eStories.billing.model'
]).controller('PromoEligibilityCtrl', [
    'ModalsModel',
    '$uibModalInstance',
    function (ModalsModel, $uibModalInstance) {
        var promoEligibilityCtrl = this;

        promoEligibilityCtrl.closeModal = function () {
            $uibModalInstance.close();
        };
    }
]);
